import VeeValidate from 'vee-validate'
import messagesPt from 'vee-validate/dist/locale/pt_BR'
import messagesEn from 'vee-validate/dist/locale/en'
import messagesEs from 'vee-validate/dist/locale/es'
import {i18n} from "@packages/I18n";
import {resolveLocale} from "@packages/util/locale/localeCookie";

export default {
    install(Vue) {

        const configs = {
            dictionary: {
                'pt-BR': messagesPt,
                'en': messagesEn,
                'es': messagesEs
            },
            i18n,
            locale:  resolveLocale(),


            // todo check if still validates everything
            // inject: false,
        }

        Vue.use(VeeValidate, configs)
    }
}
